import axios from 'axios'
import { CommonDepartmentResponse } from '@/api/services/common/department/common-department.dto'

class CommonDepartmentService {
    async findAllActiveByCenter(centerId: number): Promise<CommonDepartmentResponse[]> {
        const response =
            await axios.get<CommonDepartmentResponse[]>(
                `/departments/activeByCenter`,
                { params: { centerId } })
        return response.data
    }
}
export const commonDepartmentService = new CommonDepartmentService()
